export default __webpack_public_path__ + "static/media/HASSAN_FR_EPILOGFIN2.42d8ebdf.mp3";